import { ChangeDetectorRef, Component, ElementRef, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from 'src/app/services/auth.service';
import { CompressImageService } from 'src/app/services/compress-image.service';
import { DataService } from 'src/app/services/data.service';
import { User } from 'src/app/shared/models/user';
import { take } from 'rxjs/operators';
import { Subscription } from 'rxjs';

export function customNumberValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value: string = control.value;

    // Check if the value matches the pattern 58xxxxxxxxxx
    if (value && !/^58\d{10}$/.test(value)) {
      return { 'customNumber': true };
    }

    return null;
  };
}

// Function to validate Google Maps link
const googleMapsLinkValidator: ValidatorFn = (control: AbstractControl) => {
  if (!!control.value) {
    const regex = /^(https?:\/\/)?(www\.)?(google\.com\/maps\/place|maps\.app\.goo\.gl)\/[^\/\s]+/i;
    const isValid = regex.test(control.value);
    return isValid ? null : { invalidGoogleMapsLink: true };
  } else {
    return null
  }
};

@Component({
  selector: 'app-admin-account',
  templateUrl: './admin-account.component.html',
  styleUrls: ['./admin-account.component.scss']
})
export class AdminAccountComponent implements OnInit {
  user: any;
  profileForm: FormGroup;
  brandData: any;
  public imageUrl: any;
  @ViewChild('fileInput') el: ElementRef;
  private $imageCompressed = new EventEmitter()
  private subs = new Subscription();
  
  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private changes: ChangeDetectorRef,
    private dataService: DataService,
    private _snackBar: MatSnackBar,
    private compressService: CompressImageService,
  ) {}

  async ngOnInit() {
    this.user = await this.dataService.getUserInfo(this.authService.userData.userId);
    this.brandData = await this.dataService.getBrandData(this.authService.userData.brandId);

    this.imageUrl = this.brandData.image;

    // Initialize the profile form
    this.profileForm = this.fb.group({
      email: [this.user.email, Validators.required],
      displayName: [this.brandData.name, Validators.required],
      bio: [this.brandData?.bio],
      photoURL: [this.brandData.image, Validators.required],
      instagram: [this.brandData?.instagram],
      locationLink:  [this.brandData?.locationLink, [ googleMapsLinkValidator]], 
      whatsapp: [this.brandData?.whatsappNumber,[Validators.required, customNumberValidator()]]
    });

    this.subs = this.$imageCompressed.subscribe((compressedImage: any) => {
      let reader = new FileReader(); // HTML5 FileReader API
      // now you can do upload the compressed image 
      reader.readAsDataURL(compressedImage);
      // When file uploads set it to file formcontrol
      reader.onload = () => {
        this.imageUrl = reader.result
        this.profileForm.patchValue({
          photoURL: reader.result
        });
        this.changes.detectChanges();
      }
    });
  }

  async onSubmit() {
    if (this.profileForm.valid) {
      const updatedProfile = this.profileForm.value;
      this.dataService.updateUserInfo(updatedProfile, this.user.brandId).then(()=>{
        this._snackBar.open('Perfil actualizado correctamente ;)', 'Ok', {
          duration: 3000
        });

      })
    }
  }

  public deleteImage(): void {
    this.imageUrl = null;
    this.profileForm.patchValue({
      photoURL: null
    });
  }

  public uploadFile(event: any) {
    let file = event.target.files[0];

    if (event.target.files && event.target.files[0]) {
      this.compressImage(file)
    }
  }

  private compressImage(file: File): void {

    this.compressService.compress(file)
    .pipe(take(1))
    .subscribe((compressedImage: any) => {
      this.$imageCompressed.next(compressedImage)
      return;
    })
  }
}